export function sortNonNFTTokensList(tokenList: any) {
    // Separate 'BTX Lock' and 'BTX Unlock' tokens from the rest
    const btxLockTokens = [];
    const btxUnlockTokens = [];
    const otherTokens = [];

    for (const token of tokenList) {
        if (token.symbol === 'BTX (Lock)') {
            btxLockTokens.push(token);
        } else if (token.symbol === 'BTX (Unlocked)') {
            btxUnlockTokens.push(token);
        } else if (token.symbol){
            otherTokens.push(token);
        }
    }
    // Sort the other tokens alphabetically by symbol
    otherTokens.sort((a: any, b: any) => {
        return a.symbol.localeCompare(b.symbol);
    });
    
    // Combine the sorted tokens into a new list
    const sortedList = [...btxLockTokens, ...btxUnlockTokens, ...otherTokens];
    return sortedList;
}

type TokenType = {
    nft?: any;
    token: any;
};

const handleNewNFTToken = (
    token: TokenType,
    nftTokensList: any[],
    setNFTTokensList: Function,
    forceUpdate: Function
) => {
    for (let i = 0; i < nftTokensList.length; i++) {
        if (
            nftTokensList[i].contractAddress === token.nft.contractAddress &&
                nftTokensList[i].tokenId === token.nft.tokenId
        ) {
            nftTokensList[i] = token.nft;
            setNFTTokensList(nftTokensList);
            forceUpdate();
            return;
        }
    }
    nftTokensList.push(token.nft);
    setNFTTokensList(nftTokensList);
    forceUpdate();
};

const handleNewNonNFTToken = (
  token: TokenType,
  nonNFTTokensList: any[],
  setNonNFTTokensList: Function,
  sortNonNFTTokensList: Function,
  forceUpdate: Function
) => {
  for (let i = 0; i < nonNFTTokensList.length; i++) {
    if(nonNFTTokensList[i].id === token.token.id){
      nonNFTTokensList[i] = token.token;
      let sortedList = sortNonNFTTokensList(nonNFTTokensList);
      setNonNFTTokensList(sortedList);
      forceUpdate();
      return;
    }
  }
  nonNFTTokensList.push(token.token);
  let sortedList = sortNonNFTTokensList(nonNFTTokensList);
  setNonNFTTokensList(sortedList);
  forceUpdate();
};

function removeDuplicate({tokenList}:any){
    let uniqueTokenList = [];
    
    for (let i = 0; i < tokenList.length; i++) {
        let duplicate = false;
        for (let j = 0; j < uniqueTokenList.length; j++) {
            if (tokenList[i].chain === uniqueTokenList[j].chain &&
                tokenList[i].contractAddress === uniqueTokenList[j].contractAddress) {
                duplicate = true;
                break;
            }
        }
        if (!duplicate) {
            uniqueTokenList.push(tokenList[i]);
        }
    }
    return uniqueTokenList;
}

export { handleNewNFTToken, handleNewNonNFTToken, removeDuplicate };

